import { render, staticRenderFns } from "./PagePanel.vue?vue&type=template&id=56c8bff2&scoped=true&"
import script from "./PagePanel.vue?vue&type=script&lang=js&"
export * from "./PagePanel.vue?vue&type=script&lang=js&"
import style0 from "./PagePanel.vue?vue&type=style&index=0&id=56c8bff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8bff2",
  null
  
)

export default component.exports